/* src/app/core/widgets/discussion/discussion.component.scss */
.discussionItem {
  display: flex;
  flex-flow: row wrap;
}
.discussionItem div {
  padding: 1rem;
}
/*# sourceMappingURL=discussion.component.css.map */
